import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { apDungCoChu, docCoChu } from './vo';

// Đặt cỡ chữ ĐÃ CHỌN trước khi vẽ dòng đầu tiên.
// Làm trong một useEffect thì trang hiện cỡ chuẩn rồi mới nhảy sang cỡ lớn —
// người lớn tuổi nhìn thấy chữ giật mỗi lần mở app.
apDungCoChu(docCoChu());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* BrowserRouter cho phép app có nhiều trang với địa chỉ riêng
        (/bang-tin, /trang-cua-toi, /quan-tri) và nút Quay lại của trình
        duyệt hoạt động đúng.

        ⚠️ Cần đi kèm luật "SPA fallback" trong public/web.config, nếu không
        thì bấm F5 ở các trang đó sẽ ra lỗi 404 của IIS. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
